module.exports = __webpack_public_path__ + "static/media/simulate.0cd5c4e8.svg";